import { useToast } from "@chakra-ui/react";
import useCompany from "./useCompany";
import useDefaultPage from "@shared/hooks/useDefaultPage";
import type { Company, CompanyValues, UpdateCompanyEstatusPayload} from "../types/company";


const useCompanyPage = () => {
    const toast = useToast()
    const { companies, createCompany, updateCompany, deleteCompany, updateCompanyStatus } = useCompany()
    const {
        selectedItem, 
        isOpenDrawer,
        isOpenDialog,
        onCloseDilog, 
        setIsOpenDrawer, 
        onPressAddItem, 
        onPressEditItem,
        onPressDeleteItem
    } = useDefaultPage<Company>()

    const onCreateCompany = async(values: CompanyValues) => {
        const result = await createCompany({
            nombre: values.nombre,
        })

        if(result.isErr()){
            toast({
                title: 'Agregar sociedad',
                description: 'Error al agregar sociedad',
                status: 'error',
                duration: 9000,
                isClosable: true
            })

            return false
        }

        toast({
            title: 'Agregar sociedad',
            description: 'Sociedad agregada',
            status: 'success',
            duration: 9000,
            isClosable: true
        })

        return true
    }

    const onUpdateCompany = async(id: number, values:CompanyValues) => {
        const result = await updateCompany({
            id,
            nombre: values.nombre,
        })

        if(result.isErr()) {
            toast({
                title: 'Actualizar sociedad',
                description:'Error al actualizar sociedad',
                status: 'error',
                duration: 9000,
                isClosable: true
            })
            return false
        }

        toast({
            title: 'Actualizar sociedad',
            description: 'Sociedad actualizada',
            status: 'success',
            duration: 9000,
            isClosable: true
        })

        return true
    }

    const onDeleteCompany = async() => {
    
        if(!selectedItem) return

        const result = await deleteCompany(selectedItem.id)

        if(result.isErr()){
            toast({
                title: 'Eliminar sociedad',
                description:'Error al eliminar sociedad',
                status: 'error',
                duration: 9000,
                isClosable: true
            })
            return
        }

        toast({
            title: 'Eliminar sociedad',
            description: 'Sociedad eliminada',
            status: 'success',
            duration: 9000,
            isClosable: true
        })

    }

    const onPressPlayStop = async (values: UpdateCompanyEstatusPayload) => {

        const result = await updateCompanyStatus({ id: values.id, action: values.action })

        if (result.isErr() && values.action === 'active'){
            toast({
                title: 'Cambiar estado sociedad',
                description: 'Error al cambiar a inactiva la sociedad',
                status: 'error',
                duration: 9000,
                isClosable: true
            })
            return false
        } else if (result.isErr() && values.action === 'inactive'){
            toast({
                title: 'Cambiar estado sociedad',
                description: 'Error al cambiar a activa la sociedad',
                status: 'error',
                duration: 9000,
                isClosable: true
            })
            return false
        }

        toast({
            title: 'Cambiar estado sociedad',
            description: 'se ha cambiado el estado de la sociedad',
            status: 'success',
            duration: 9000,
            isClosable: true
        })
        return true
    }

    return{
        companies,
        selectedItem,
        isOpenDrawer,
        isOpenDialog,
        onCloseDilog,
        setIsOpenDrawer,
        onPressAddItem,
        onPressEditItem,
        onPressDeleteItem,
        onCreateCompany,
        onUpdateCompany,
        onDeleteCompany,
        onPressPlayStop
    }
}

export default useCompanyPage;